import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ClientRoutes from "./Routes";
import MainEfrat from "../components/efrat/MainEfrat";

const EfratSwitch = () => {
  return (
    <Switch>
      <Route
        path={ClientRoutes.Efrat.main}
        component={(props) => <MainEfrat {...props} />}
      />
      <Redirect from="/" to={ClientRoutes.Efrat.main} />
    </Switch>
  );
};

export default EfratSwitch;
